import * as React from 'react';
import { AppContext, IAppContext } from './Types/Intyg.types';
import AktuellLegitimation from './Forms/AktuellLegitimation';
import { FormType, ReCaptchaFormName, FieldName } from './Types/Intyg.enums';
import EjRegleratYrke from './Forms/EjRegleratYrke';
import { LegitimationInomEU } from './Forms/LegitimationInomEU';
import Kontaktlinsbehorighet from './Forms/Kontaktlinsbehorighet';
import { IGoogleReCaptchaConsumerProps } from 'react-google-recaptcha-v3';
import { MailTypeFieldName, MailType } from '../../models/email.types';
import { ApiService } from './Services/intyg.api.service';
import { Artikel3_3 } from './Forms/Artikel3_3';
import { ResponseError } from 'sos-common/js';
import Forskrivningsratt from './Forms/Forskrivningsratt';
import AT_Tjanstgoring from './Forms/AT_Tjanstgoring';
import { LocalFieldName } from './FormSections/FileUploaderClientOnly';

const CaptchaFieldName = '__captchaToken';

export interface IWebformWrapperProps {
  googleReCaptchaProps?: IGoogleReCaptchaConsumerProps | undefined;
}

export interface IWebformWrapperState {}

export class WebformWrapper extends React.Component<IWebformWrapperProps, IWebformWrapperState> {
  static contextType = AppContext;
  //@ts-expect-error
  public context: IAppContext = this.context;
  private _formRef: React.RefObject<HTMLFormElement>;

  constructor(props: IWebformWrapperProps, context: IAppContext) {
    super(props);

    context.onClickSubmitButton = this.submitForm;

    this._formRef = React.createRef();

    this.state = {};
  }

  getRecaptchaFormName = () => {
    switch (this.context.formType) {
      case FormType.Intyg_for_aktuell_legitimation:
        return ReCaptchaFormName.Intyg_for_aktuell_legitimation;
      case FormType.Intyg_om_ej_reglerat_yrke:
        return ReCaptchaFormName.Intyg_om_ej_reglerat_yrke;
      case FormType.Intyg_om_kontaktlinsbehorighet:
        return ReCaptchaFormName.Intyg_om_kontaktlinsbehorighet;
      case FormType.Intyg_for_legitimation_inom_EU:
        return ReCaptchaFormName.Intyg_for_legitimation_inom_EU;
      case FormType.Artikel_33:
        return ReCaptchaFormName.Artikel_33;
      case FormType.Intyg_om_AT_tjanstgoring:
        return ReCaptchaFormName.Intyg_om_AT_tjanstgoring;
      case FormType.Intyg_om_forskrivningsratt:
        return ReCaptchaFormName.Intyg_om_forskrivningsratt;
      default:
        return 'intyg_undefined_form';
    }
  };

  submitForm = (isFormValid: boolean) => {
    const { forceComponentTreeReRender } = this.context;
    this.context.setSubmitButtonAsClicked(() => {
      if (isFormValid) {
        this.context.showSpinner = true;
        forceComponentTreeReRender();

        let formData = new FormData(this._formRef.current);

        this.props.googleReCaptchaProps.executeRecaptcha(this.getRecaptchaFormName()).then(
          (token) => {
            formData.append(CaptchaFieldName, token);
            formData.append(MailTypeFieldName, MailType.Intyg.toString());
            if (this.context.model.bilagor) {
              this.context.model.bilagor.forEach((x) => {
                formData.append(LocalFieldName.doc_tjanstgoringsintyg, x.file);
              });
            }
            ApiService.call.sendWebForm(formData).then(
              (response) => {
                if ((response as any)?.errorMessage === null) {
                  this.context.isFormTouched = false;
                  window.location.href = this.context.thankYouPage;
                }
              },
              (rejectReason) => {
                //dialogue trigger
                this.context.showSpinner = false;
                forceComponentTreeReRender();
                console.log(rejectReason);
              }
            );
          },
          (rejection) => {
            this.context.showSpinner = false;
            forceComponentTreeReRender();
            console.log(rejection);
          }
        );
      }
    });
  };

  renderForm = () => {
    switch (this.context.formType) {
      case FormType.Intyg_for_aktuell_legitimation:
        return <AktuellLegitimation />;
      case FormType.Intyg_om_ej_reglerat_yrke:
        return <EjRegleratYrke />;
      case FormType.Intyg_om_kontaktlinsbehorighet:
        return <Kontaktlinsbehorighet />;
      case FormType.Intyg_for_legitimation_inom_EU:
        return <LegitimationInomEU />;
      case FormType.Artikel_33:
        // eslint-disable-next-line react/jsx-pascal-case
        return <Artikel3_3 />;
      case FormType.Intyg_om_AT_tjanstgoring:
        // eslint-disable-next-line react/jsx-pascal-case
        return <AT_Tjanstgoring />;
      case FormType.Intyg_om_forskrivningsratt:
        return <Forskrivningsratt />;
      default:
        return <div>Det angivna formuläret har ingen känd formulärtyp.</div>;
    }
  };

  public render() {
    return (
      <form noValidate ref={this._formRef}>
        {this.renderForm()}
        <input type="hidden" name={FieldName.ContentId} value={this.context.contentId} />
        <input type="hidden" name={FieldName.LanguageId} value={this.context.formLanguage} />
      </form>
    );
  }
}
